import * as React from 'react';
import TooltipComponent from '../../TooltipComponent';

interface ISwitchProps {
  label: string;
  id: string;
  required?: boolean;
  disabled?: boolean;
  tooltip?: string;
  isRight?: boolean;
  noMargin?: boolean;
  isChangeDetail?: string;
  fullOpacity?: boolean;
  value?: string;
}

export default function Switch(props: ISwitchProps) {
  const handleStyle = () => {
    if (props.noMargin) {
      return { marginTop: '-16px', marginBottom: '0' };
    }
    if (props.isRight) {
      return { marginBottom: '0' };
    }
    return {};
  };

  return (
    <div className="switch-component form-group" style={handleStyle()}>
      <div className={props.isRight ? '' : 'row'} style={{ position: 'relative' }}>
        <label
          className={props.isRight ? '' : 'col-12 col-lg-3 form-label'}
          style={
            props.isRight ? { paddingLeft: '32px', paddingBottom: '6px', paddingRight: '83px' } : {}
          }
        >
          {props.required && <span className="text-danger required-field-info">*</span>}
          {props.label}
        </label>
        <div
          className={props.isRight ? '' : 'col-12 col-xl-10'}
          style={props.isRight ? { position: 'absolute', top: 0, right: 0 } : {}}
        >
          <div className="row">
            <div className="col-12 col-xl-8">
              <div className="e-checkbox-switch" title={props.tooltip || ''}>
                {props.isChangeDetail ? (
                  <TooltipComponent
                    id={props.id}
                    firstItems={true}
                    width="180px"
                    positionRight={true}
                    overlay={<div style={{ color: '#fff' }}>{props.isChangeDetail}</div>}
                  >
                    <label>
                      <div
                        style={{
                          background: '#3669BB',
                          position: 'absolute',
                          width: '36px',
                          height: '20px',
                          zIndex: 1,
                          opacity: 0.3,
                          borderRadius: '8px',
                          left: '-5px',
                        }}
                      />
                      <input
                        type="checkbox"
                        value="1"
                        checked={String(props.value) === '1'}
                        disabled={true}
                        className="change-detail"
                      />

                      <span />
                    </label>
                  </TooltipComponent>
                ) : (
                  <label>
                    <input
                      type="checkbox"
                      value="1"
                      checked={String(props.value) === '1'}
                      disabled={props.disabled}
                      placeholder={props.disabled ? 'Nastav si poriadne pravidla' : ''}
                      className={props.fullOpacity ? 'change-detail' : ''}
                    />
                    <span />
                  </label>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
